import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Services from '@/components/Services'
import Difference from '@/components/Difference'
import QuestionResult from '@/components/QuestionResult'
import SingleService from '@/components/SingleService'
import Approach from '@/components/Approach'
import About from '@/components/About'
import AboutSingle from '@/components/AboutSingle'
import Contact from '@/components/Contact'
import Error404 from '@/components/404'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/services',
      name: 'Services',
      component: Services
    },
    {
      path: '/services/:name',
      name: 'SingleService',
      component: SingleService
    },
    {
      path: '/questionnaire/whats-the-difference',
      name: 'Difference',
      component: Difference
    },
    {
      path: '/questionnaire/:slug',
      name: 'QuestionResult',
      component: QuestionResult
    },
    {
      path: '/our-approach',
      name: 'Approach',
      component: Approach
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/about-us',
      component: About,
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: '',
          name: 'About',
          component: AboutSingle
        }
      ]
    },
    {
      path: '/*',
      component: Error404,
      name: '404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js